<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_v"></a>To my parents, Isaac and Frances,<br/>for the love and education they gave me<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?396a48a3